// Centralized keepUnusedDataFor (seconds) values for opt-in RTK Query caching
// (spec 12 / code-review FE-5). The global default in service.ts stays 0; only
// allowlisted lookup endpoints opt in. See specs/12-rtk-query-caching/.
export const CACHE_TTL = {
  /**
   * Select-option / lookup lists that are correctly tag-invalidated: a create or
   * edit refreshes them immediately, so this TTL only caps how long an *external*
   * change (another user / admin) can look stale.
   */
  LOOKUP: 120,
  /**
   * Very stable reference data (rarely edited); safe to serve from cache for longer.
   */
  REFERENCE: 300,
} as const;
